import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b313d92c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-bg" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "spinner",
    viewBox: "0 0 50 50"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      "stroke-width": "5"
    })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}